interface Dictionary<T> {
  [key: string]: T
}
type Categories = 'Familien' | 'Nice Price' | 'Stadt' | 'Ferien' | 'Wellness'
export const categories: Dictionary<[string, string, string, string]> = {
  Ferien: [
    'rgb(82, 83, 148)',
    'rgb(173, 66, 127)',
    'rgba(173, 66, 127, 0)',
    'purple'
  ],
  'Nice Price': [
    'rgb(255, 202, 24)',
    'rgba(248, 129, 61, 1)',
    'rgba(248, 129, 61, 0)',
    'orange'
  ],
  Wellness: [
    'rgb(0, 161, 202)',
    'rgba(29, 95, 130, 1)',
    'rgba(29, 95, 130, 0)',
    'teal'
  ],
  Stadt: [
    'rgb(173, 66, 127)',
    'rgba(226, 60, 78, 1)',
    'rgba(226, 60, 78, 0)',
    'red'
  ],
  Familien: [
    'rgb(84, 175, 113)',
    'rgba(69, 101, 88, 1)',
    'rgba(69, 101, 88, 0)',
    'green'
  ]
}
